import { render, staticRenderFns } from "./non-uom-prices.vue?vue&type=template&id=f9fc3304"
import script from "./non-uom-prices.vue?vue&type=script&lang=js"
export * from "./non-uom-prices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports